export const ROLE_LABELS = {
  owner: "Owner",
  warehouse_admin: "Admin Gudang",
  purchasing: "Purchasing",
  qc_team: "Tim QC",
  supervisor: "Kepala Gudang/SPV",
  sales: "Sales",
  picker: "Picker",
  packer: "Packer",
  rnd: "R&D",
  production_admin: "Admin Produksi",
  production_spv: "SPV Produksi",
  cutting: "Cutting",
  accounting: "Accounting",
  viewer: "Viewer/Accounting",
};
